<template>
  <div class="container">
    <md-card class="dash-content">
      <div class="header-wrapper">
        <PageHeader :title="id ? 'Update Testimonial' : 'Create Testimonial'" />
        <div>
          <md-button :to="{ name: 'Testimonial' }" class="md-primary">
            Back
          </md-button>
        </div>
      </div>

      <div>
        <form novalidate class="md-layout" @submit.prevent="validateUser">
          <md-field :class="getValidationClass('attestant')">
            <label>Name</label>
            <md-input v-model="form.attestant" required></md-input>
            <span class="md-error" v-if="!$v.form.attestant.required"
              >Name is required</span
            >
          </md-field>

          <md-field :class="getValidationClass('body')">
            <label>Content</label>
            <md-textarea v-model="form.body" required></md-textarea>
            <span class="md-error" v-if="!$v.form.body.required"
              >content is required</span
            >
          </md-field>

          <md-field>
            <label>Image</label>
            <!-- v-model="form.image" -->
            <!-- <md-file
              type="file"
              accept="image/*"
              name="media"
              @md-change="(e) => handleFile(e)"
            /> -->
            <input id="media" type="file" @change="handleFiles" name="media" />
          </md-field>

          <md-field :class="getValidationClass('state')">
            <label for="user_type">Publish</label>
            <md-select v-model="form.status" name="status" id="status">
              <md-option value="" disabled>Select Status</md-option>
              <md-option value="Live">Live</md-option>
              <md-option value="Draft">Draft</md-option>
            </md-select>
          </md-field>

          <mdc-button :loading="loading">{{
            id ? "Update Testimonial" : "Create Testimonial"
          }}</mdc-button>
        </form>
      </div>
    </md-card>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength, email } from "vuelidate/lib/validators";
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapGetters } = createNamespacedHelpers("testimonial");

export default {
  mixins: [validationMixin],
  data: () => ({
    form: {},
    loading: false,
    fetching: false,
    metadata: null
  }),
  validations: {
    form: {
      attestant: {
        required
      },
      body: {
        required
      }
    }
  },
  methods: {
    ...mapActions([
      "createTestimonial",
      "updateCategory",
      "getCatMetadata",
      "getCat"
    ]),
    handleFiles(e) {
      let file = e.target.files[0];
      this.url = URL.createObjectURL(file);
      this.form.media = file;
      this.filename = file.name;
    },
    async validateUser() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let data = { ...this.form };

        try {
          this.loading = true;
          let call = this.id
            ? this.updateTestimonial(data)
            : this.createTestimonial(data);
          let msg = this.id ? "Testimonial Updated" : "Testimonial Created";
          await call;
          this.toast("success", msg);
          this.$router.push({ name: "Testimonial" });
          this.loading = false;
        } catch (err) {
          console.log(err);
          this.loading = false;
          this.toast("error", "Opps, Something went wrong ");
        }
      }
    },
    async getMeta() {
      this.fetching = true;
      const res = await this.getCatMetadata();
      this.fetching = false;
      this.metadata = res;
    }
  },
  mounted() {
    this.getMeta();
    if (this.id) {
      this.getCat(this.id).then((testimonial) => {
        this.form = {
          id: testimonial.id,
          attestant: testimonial.attestant,
          body: testimonial.body
        };
      });
    }
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  }
};
</script>

<style scoped lang="scss">
.feature-attributes {
  width: 100%;
  .wrapper {
    display: flex;
    align-items: center;
    gap: 20px;

    .val {
      flex: 1;
    }

    .attr {
      width: 25%;
    }
  }
}
</style>
